import React from "react";

function UserProfile({ user }) {
  // console.log(user.accountBalance);
  return (
    <div className="bg-gray-800 p-4 rounded-lg shadow-md">
      <div className="ml-3">
        <p className="text-sm font-medium text-gray-100">
          {user.firstName} {user.lastName}
        </p>
        <p className="text-sm text-gray-400">
          Account: ${user.accountBalance?.toFixed(2)}
        </p>
      </div>
    </div>
  );
}

export default UserProfile;
